import React from "react";
import styles from "./box.module.css";

const Box = () => {
    return (
        <div className={styles.container}>
            <div className={`${styles.box} ${styles.green}`}>
                <h2 className={styles.titleBox}>پک 1</h2>
                <p className={styles.boxPrice}>۲۰۰,۰۰۰ تومان</p>
                <p className={styles.boxPrice}>+</p>
                <p className={styles.boxOffPrice}>۲۰,۰۰۰ تومان شارژ هدیه</p>
            </div>
            <div className={`${styles.box} ${styles.pink}`}>
                <h2 className={styles.titleBox} >پک 2</h2>
                <p className={styles.boxPrice}>۵۰۰,۰۰۰ تومان</p>
                <p className={styles.boxPrice}>+</p>
                <p className={styles.boxOffPrice}>۱۰۰,۰۰۰ تومان شارژ هدیه</p>
            </div>
            <div className={`${styles.box} ${styles.purple}`}>
                <h2 className={styles.titleBox}>پک 3</h2>
                <p className={styles.boxPrice}>۱,۰۰۰,۰۰۰ تومان</p>
                <p className={styles.boxPrice}>+</p>
                <p className={styles.boxOffPrice}> ۲۵۰,۰۰۰ تومان شارژ هدیه </p>
            </div>
            <div className={`${styles.box} ${styles.khaki}`}>
                <h2 className={styles.titleBox}>پک 4</h2>
                <p className={styles.boxPrice}>۲,۰۰۰,۰۰۰ تومان</p>
                <p className={styles.boxPrice}>+</p>
                <p className={styles.boxOffPrice}>۷۵۰,۰۰۰تومان شارژ هدیه</p>
            </div>
        </div>
    );
};

export default Box;
